const EXPORT_ALL_RECORDS_IN_VIEW = 'exportAllRecordsInView';
const EXPORT_SELECTED_RECORDS = 'exportSelectedRecords';
const EXPORT_PRIMARY_RECORDS = 'exportPrimaryRecords';
const EXPORT_PRIMARY_RECORDS_AND_LINE_ITEMS = 'exportPrimaryRecordsAndLineItems';
const SHIPMENT_RECORD_EXPORT = 'shipmentRecordExport';
const FULFILLMENT_RECORD_EXPORT = 'fulfillmentRecordExport';
const ORDER_RECORD_EXPORT = 'orderRecordExport';
const ORDER = 'Order';
const ORDER_LINE_ITEM = 'OrderLineItem';
const SHIPMENT = 'Shipment';
const SHIPMENT_LINE_ITEM = 'ShipmentLineItem';
const FULFILLMENT = 'Fulfillment';
const FULFILLMENT_LINE_ITEM = 'FulfillmentLineItem';

export const ExportOptions = {
  EXPORT_ALL_RECORDS_IN_VIEW,
  EXPORT_SELECTED_RECORDS,
  EXPORT_PRIMARY_RECORDS,
  EXPORT_PRIMARY_RECORDS_AND_LINE_ITEMS,
  SHIPMENT_RECORD_EXPORT,
  FULFILLMENT_RECORD_EXPORT,
  ORDER_RECORD_EXPORT,
  ORDER,
  ORDER_LINE_ITEM,
  SHIPMENT,
  SHIPMENT_LINE_ITEM,
  FULFILLMENT,
  FULFILLMENT_LINE_ITEM,
};

export const ExportOptionsValues = Object.values(ExportOptions);
